import React from 'react'
import { Button } from 'react-bootstrap'
import { FaRegFilePdf } from 'react-icons/fa6'


export default function PDF(props) {

    const { onClick, tooltip_content } = props

    return (
        <>
            <Button
                variant="outline-danger"
                size='sm'
                onClick={onClick}
                className={localStorage.getItem('lang_key') == 'ar' ? 'me-1' : 'ms-1'}
                data-tooltip-id="global-table-tooltip"
                data-tooltip-content={tooltip_content}
                data-tooltip-place="bottom"
                data-tooltip-class-name="bg-danger tooltip_msg"
            >
                <FaRegFilePdf className='mb-1' size={14} />
            </Button>
        </>
    )
}
